export default __webpack_public_path__ + "static/media/dashboard_loading.4f026260.svg";